import React from "react";
import MainScreen from "../MainScreen/MainScreen";
import {
  telephone,
  mail,
  facebook,
  github,
  instagram,
  leetcode,
  linkedin,
  snapchat,
  whatsapp,
} from "../../assets/index.js";

const Contact = () => {
  const subHeading = [
    "Reach Out",
    "Ping Me",
    "Let’s Chat",
    "Connect Now",
    "Get Involved",
  ];

  const handleIconClick = () => {
    window.open("https://google.com", "_blank");
  };

  return (
    <MainScreen heading={"Contact Me"} subHeading={subHeading}>
      <div className="contactWrapper">
        <div className="contactInfo">
          <div className="contactItem">
            <img src={telephone} alt="Phone" onClick={handleIconClick} />
            <span>+91 9457441847</span>
          </div>
          <div className="contactItem">
            <img src={mail} alt="Email" onClick={handleIconClick} />
            <span>akshaytomar891@gmail.com</span>
          </div>
        </div>
        <div className="socialIcons">
          <div className="socialIcon" onClick={handleIconClick}>
            <img src={facebook} alt="Facebook" />
          </div>
          <div className="socialIcon" onClick={handleIconClick}>
            <img src={github} alt="GitHub" />
          </div>
          <div className="socialIcon" onClick={handleIconClick}>
            <img src={instagram} alt="Instagram" />
          </div>
          <div className="socialIcon" onClick={handleIconClick}>
            <img src={leetcode} alt="LeetCode" />
          </div>
          <div className="socialIcon" onClick={handleIconClick}>
            <img src={linkedin} alt="LinkedIn" />
          </div>
          <div className="socialIcon" onClick={handleIconClick}>
            <img src={snapchat} alt="Snapchat" />
          </div>
          <div className="socialIcon" onClick={handleIconClick}>
            <img src={whatsapp} alt="WhatsApp" />
          </div>
        </div>
      </div>
    </MainScreen>
  );
};

export default Contact;
